import { axios } from '$app-web/api/axios';
import { transformToSnakeCase } from '$app-web/utils';

import { Endpoints } from '../constant';

interface IResponse {
    device: {
        appUpdatedAt: number | null;
        btMac: string | null;
        curAppVersion: number | null;
        curOsVersion: string | null;
        dateCreated: number | null;
        deviceId: string | null;
        lastAppVersion: number | null;
        lastOsVersion: string | null;
        lastUsed: number | null;
        manufacturer: string | null;
        model: string | null;
        osUpdatedAt: number | null;
        owner: number | null;
        wifiMac: string | null;
    };
    user: {
        username: string;
        roleId: number;
        id: number;
        avatar: string;
        firstName: string;
        lastName: string;
        language: string;
        orgName: string;
        isEmailVerified: boolean;
        isPhoneVerified: boolean;
        mfaEnabled: boolean;
        phone: string;
        matrixPassword: string;
        subscriptionConfigs: unknown;
        preferredNotificationMediumIds: Array<number>;
        hasAutoLogout: boolean;
        hasPasswordExpiry: boolean;
        // TODO: Below fields are deprecate. Remove them after adjusting the UI in PDash.
        genderId: number;
        ageId: number;
        educationId: number;
        maritalStatusId: number;
        occupationId: number;
        salaryId: number;
    };
}

interface RequestData {
    firstName?: string;
    lastName?: string;
    language?: string;
    gender?: string;
    ageId?: string | number;
    maritalStatusId?: string | number;
    educationId?: string | number;
    occupationId?: string | number;
    salaryId?: string | number;
}

export async function updateProfile(profileData: RequestData) {
    const normalizedPayloadData = transformToSnakeCase(profileData);

    try {
        const { data } = await axios.patch<IResponse>(Endpoints.User.Root, normalizedPayloadData);

        return data;
    } catch (error) {
        return null;
    }
}
